<template>
    <div>
        <label :style="'color:' + fieldsColor" :class="{'required': field.required}">
            {{ field.name }}
            <help-tooltip :content="field.helpDescription"></help-tooltip>
        </label>

        <div v-for="(communication, index) in communications">
            <div class="d-flex mb-3">
                <v-text-field
                  v-model="communication.value"
                  :autocomplete="fieldCode"
                  @change="setDirtyTabulation('COMMUNICATIONS')"
                  outlined
                  hide-details
                  :readonly="readOnly"
                  :id="'field-' + fieldCode + '-' + index"
                  :class="{'input-error': checkFormat(communication) !== '' ||
                  (submitted && field.required && (communication.value === null || communication.value === ''))}"
                >
                </v-text-field>
                <v-tooltip bottom class="mt-auto mb-auto">
                    <template v-slot:activator="{ on }">
                        <v-icon color="gray"
                                v-on="on"
                                v-if="index !== 0 && !readOnly"
                                class="ml-2 mt-auto mb-auto"
                                large
                                @click="deleteCom(communication)">close
                        </v-icon>
                    </template>
                    <div>Supprimer</div>
                </v-tooltip>
            </div>
            <div class="txt-error mt-1">
                {{ checkFormat(communication) }}
            </div>
        </div>

        <v-btn text
               :color="primaryColor"
               class="text-none contact-btn mt-2"
               style="padding-left: 0; font-size: 19px"
               @click="addCom"
               v-if="!readOnly">
            <v-icon class="mr-2" :color="primaryColor" style="font-size: 30px">add</v-icon>
            Ajouter {{ getComButtonWord() }}
        </v-btn>
    </div>
</template>

<script>
import HelpTooltip from "../../../tools/HelpTooltip.vue"

import { mapGetters, mapMutations, mapState } from "vuex"
import { fieldsMapping } from "../../../../static/webform"

import PhoneNumber from "awesome-phonenumber"
import * as EmailValidator from "email-validator"

export default {
    name: "FormCommunication",
    props: ["field"],
    components: { HelpTooltip },
    computed: {
        ...mapState("webFormStyle", ["primaryColor", "fieldsColor"]),
        ...mapState("web_form", ["submitted", "provider", "readOnly"]),
        ...mapGetters("web_form", ["getCodeFromField", "getProviderFieldValue"]),
        ...mapState("resource", ["communicationTypes"]),
        fieldCode() {
            return this.getCodeFromField(this.field)
        },
        communications() {
            return this.provider.communications.filter(communication => communication.type.name === this.fieldCode)
        },
        path() {
            return fieldsMapping.find(path => path.code === this.fieldCode)
        },
    },
    methods: {
        ...mapMutations("web_form", ["updateProviderFieldValue", "setDirtyTabulation",]),
        getComButtonWord(contact) {
            let label = null

            switch (this.fieldCode) {
                case "EMAIL":
                    label = " une adresse email"
                    break
                case "PHONE":
                    label = " un téléphone"
                    break
                case "FAX":
                    label = " un fax"
                    break
                case "FREE_PHONE":
                    label = " un téléphone sans frais"
                    break
                default:
                    label = " un lien " + contact.label
            }

            return label
        },
        addCom(withFocus = true) {
            let communications = this.getCommunicationByType()

            if (communications !== undefined && communications !== null) {
                if (communications.length === 0 ||
                  (communications[communications.length - 1].value !== "" &&
                    communications[communications.length - 1].value !== null
                  )
                ) {
                    let type = this.communicationTypes.find(type => type.name === this.fieldCode)
                    let com = {
                        value: null,
                        type: type,
                    }

                    this.provider.communications.push(com)

                    this.$forceUpdate()

                    communications = this.getCommunicationByType()
                }

                if (withFocus) {
                    setTimeout(() => {
                        communications = this.getCommunicationByType()

                        let elt = document.getElementById("field-" + this.fieldCode + "-" + (communications.length - 1))

                        elt.focus()
                    }, 200)
                }

                this.setDirtyTabulation('COMMUNICATIONS')
            }
        },
        deleteCom(com) {
            let communications = this.communications

            if (communications.length > 1) {
                let foundIndex = null
                this.provider.communications.forEach((communication, index) => {
                    if (communication.value === com.value && com.type.name === communication.type.name) {
                        foundIndex = index
                    }
                })

                if (foundIndex !== null) {
                    this.provider.communications.splice(foundIndex, 1)
                }

                this.$forceUpdate()
            } else {
                com.value = null
            }

            this.setDirtyTabulation('COMMUNICATIONS')
        },
        getCommunicationByType() {
            return this.provider.communications.filter(com => {
                return com.type.name === this.fieldCode
            })
        },
        checkFormat(com) {
            let result = ""

            if (['PHONE', 'FREE_PHONE'].includes(com.type.name) && com.value !== null && com.value !== "") {
                let phoneFr = new PhoneNumber(com.value, "FR")
                let phoneNc = new PhoneNumber(com.value, "NC")
                let phoneCa = new PhoneNumber(com.value, "CA")

                result = (phoneFr.isValid() || phoneNc.isValid() || phoneCa.isValid()) ?
                  "" : "Le format du téléphone n'est pas correct"
            }

            if (com.type.name === "EMAIL" && com.value !== null && com.value !== "") {
                let isValidEmail = EmailValidator.validate(com.value)
                result = isValidEmail ? "" : "Le format de l'e-mail n'est pas correct"
            }

            return result
        },
    },
    created() {
        let communications = this.getCommunicationByType()

        if (communications !== undefined && communications !== null && communications.length === 0) {
            this.addCom(false)
        }
    },
}
</script>